import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'openModal'
        }
    }

    openModal(e) {
        const target = this.el
        const type = this.getData('type', target)

        let closeLabel
        let attributes = {}


        switch (type) {
            case 'newsletter':
                closeLabel = 'Close newsletter subscription modal'
                break
            case 'booking':
                closeLabel = 'Close booking form modal'
                break
            case 'events':
                closeLabel = 'Close events inquiry modal'
                attributes = {
                    type: 'events',
                    location: target.dataset.eventLocation || null,
                }
                break
            case 'rsvp':
                closeLabel = 'Close rsvp modal'
                attributes = {
                    type: 'rsvp',
                    eventTitle: target.dataset.eventTitle || null,
                    eventDates: JSON.parse(target.dataset.eventDates) || null,
                    eventId: target.dataset.eventId || null,
                }
                break
        }

        this.call('setModifier', type, 'Modal')
        this.call('setCloseLabel', closeLabel, 'Modal')
        this.call('setAttributes', attributes, 'Modal')
        this.call('open', null, 'Modal')
    }
}
